import * as z from 'zod/mini'

/**
 * Field rules for a place, shared by the forms, the HTTP bodies and the domain operation.
 *
 * `capacity` 0 means "uncapped" in the domain (`createPlace` defaults to it), so the field allows it;
 * the HTTP bodies require at least 1, because a manager setting a capacity means a real one.
 */
export const placeFields = {
  name: z.string().check(z.trim(), z.minLength(2), z.maxLength(40)),
  capacity: z.int().check(z.nonnegative(), z.maximum(500000)),
}
